import React from 'react'
import PropTypes from 'prop-types'

class GuestSubmitButton extends React.Component {

	render () {

		let { passwordFieldsOpen = false, labels: { donatenow, agreeanddonate, donatenowrec } = {} } = this.props;
		// Showing agreeanddonate incase password fileds are open
		let donateLabel = passwordFieldsOpen ? agreeanddonate : donatenow;

		donatenowrec = donatenowrec && donatenowrec.replace('{amount}', this.props.amount);

		return (
			<div style={{ maxWidth: 360, margin: '20px auto 0px' }}>
				<button type="button"
					disabled={this.props.disabled}
					style={{ marginBottom: '0px' }}
					id="guestPaymentBtn"
					className="vx_btn vx_btn-block"
					onClick={this.props.handleClick}>
					{this.props.isRecurring ? donatenowrec : donateLabel}
				</button>
			</div>
		);
	}
}

GuestSubmitButton.propTypes = {
	labels: PropTypes.object,
	amount: PropTypes.string,
	disabled: PropTypes.bool,
	isRecurring: PropTypes.bool,
	handleClick: PropTypes.func,
	passwordFieldsOpen: PropTypes.bool,
};

export default GuestSubmitButton



// WEBPACK FOOTER //
// ./components/guest-submit-button.js